<template>
  <div>

    <v-img
      :src="redirect + '/public' + details.image"
      :lazy-src="details.image"
      aspect-ratio="1"  @click.prevent="emitdescription(details)"
      class="grey lighten-2"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <div class="info-container">
      <p>
        <span class="pricing">{{ details.pricing }}</span
        >F&nbsp;|&nbsp;{{ details.pieces }}
      </p>
      <h3>{{ details.title }}</h3>
    </div>
    <div class="action-container" :style="{color:colorinfos.textCartColor,background:colorinfos.buttonCartColor}">

      <div class="trigger-add" v-if="!article_added">
        <v-btn
          :color="colorinfos.buttonCartColor"
          v-bind:text="true"
          :style="{color:colorinfos.textCartColor}"
          :disabled="details.current_order >= details.max_amount ? true : false"
          @click.prevent="btnAdd"
          width="100%"
        >
          {{
            details.current_order >= details.max_amount
              ? "Stock épuisé"
              : "Ajouter"
          }}
        </v-btn>
      </div>
      <div class="quantity-add" v-else>
        <div class="containerbutton" :style="{color:colorinfos.textCartColor,background:colorinfos.buttonCartColor}">
          <div class="elm-ctn">
            <v-btn
              depressed
              v-bind:tile="false"
              @click.prevent="removeElement"
              :color="colorinfos.buttonCartColor"
            >
              <v-icon :color="colorinfos.textCartColor"> mdi-minus </v-icon>
            </v-btn>
          </div>
          <div class="elm-ctn-quantity" :style="{color:colorinfos.textCartColor,background:colorinfos.buttonCartColor}">{{ quantity }}</div>
          <div class="elm-ctn">
            <v-btn
              depressed
              v-bind:tile="false"
              @click.prevent="addElement"
              :color="colorinfos.buttonCartColor"
            >
              <v-icon  :color="colorinfos.textCartColor"> mdi-plus </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    details: Object,
    redirect: String,
    current_quantity: Number,
    colorinfos: Object,
  },
  components: {
  },
  data() {
    return {
      article_added: false,
      quantity: 0,
      max_amount: 5,
      price: 0,
      title: "lorem ipsum",
      pricing: 1500,
      add_unity: parseInt(1),
      article_detail: {},
      colorgreen: "#00a65ad4",
      colorred: "#EF323D",

    };
  },
  watch: {
    // whenever question changes, this function will run
    current_quantity(current_changement){
        console.log(' watch ==> current_quantity yow',current_changement)
        this.equilibreQuantity(current_changement);

        //this.quantity = current_changement;
          /*  if(current_changement >= 1){
              this.article_added = true;
            }
          */
    },
    quantity: function(valquantite) {
      console.log("la valeur de la quantite", valquantite);
      if (this.quantity < 1) {
        this.article_added = false;
      }
     }
  },
  mounted(){
     console.log('mounted----->')
     this.equilibreQuantity(this.current_quantity);

  },
  methods: {
    equilibreQuantity(current_changement){
        console.log('equilibreQuantity BRANGEEEEEEEEE')
        this.quantity = current_changement;
        if(current_changement >= 1){
              this.article_added = true;
        }
    },
    removeElement() {
      if (this.quantity <= 1) {
        this.quantity = 0;
        this.article_added = false;
      } else {
        this.quantity -= 1;
      }
      this.$emit("getbackitems", {
        unit: parseInt(-this.add_unity),
        quantity: this.quantity,
        id: this.details.id
      });
    },
    emptyArticle() {
      this.quantity = 0;
    },
    btnAdd() {
      this.article_added = !this.article_added;
      this.quantity = 1;
      this.$emit("getbackitems", {
        unit: parseInt(this.add_unity),
        quantity: this.quantity,
        id: this.details.id
      });
    },
    addElement() {
      var possible_order = this.details.max_amount - this.details.current_order;
      if (this.quantity < possible_order) {
        this.quantity += 1;
        this.$emit("getbackitems", {
          unit: parseInt(this.add_unity),
          quantity: this.quantity,
          id: this.details.id
        });
      } else {
        this.$emit("maxamountnotif", {
          message:  "Vous avez atteint le nombre maximum de commande pour cette article. Vous ne pouvez pas dépasser "+possible_order+ " article(s)",
          snackbardelivery: true
        });
       }
    },
    emitdescription(description){
         this.$emit("showmedescription", {...description, ...{current_quantity: this.quantity}});
    }
  }
};
</script>

<style>
.action-container {
  /*background-color: #ef323d;*/
  width: 100%;
}
.containerbutton {
  /*background-color: #ef323d;*/
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.elm-ctn-quantity {
  font-weight: bold;
  font-size: 25px;

}

.btn-addelem {
  /*color: #fafafa p !important;*/
}

.info-container p {
  color: #929292;
  font-size: 17px;
  line-height: 1.3;
  margin: 0;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
}
.info-container > p > .pricing {
  font-size: 20px;
}
.info-container h3 {
  font-size: 18px;
  text-align: center;
  line-height: 1.3;
  margin: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/article.vue